/**
 * Temporary Invoice Configuration API Wrapper
 * 
 * This file provides placeholder implementations for the Invoice Configuration API
 * until the OpenAPI client is regenerated with the new endpoints.
 * 
 * TO REMOVE THIS FILE:
 * 1. Run: pnpm run api:generate
 * 2. Verify the following methods exist in InvoiceApi:
 *    - apiVversionInvoiceConfigurationEntityEntityIdGet
 *    - apiVversionInvoiceConfigurationPost
 *    - apiVversionInvoiceConfigurationIdPut
 *    - apiVversionInvoiceConfigurationIdDelete
 * 3. Remove this file
 * 4. Update InvoiceConfigurationPage.tsx to use invoiceApi directly
 */

import { InvoiceApi } from 'axiosApi/apis/invoice-api';
import { AxiosResponse } from 'axios';

export class InvoiceConfigurationApiWrapper {
  private invoiceApi: InvoiceApi;

  constructor(invoiceApi: InvoiceApi) {
    this.invoiceApi = invoiceApi;
  }

  /**
   * Get all configurations for a corporate entity
   * GET /api/v1/InvoiceConfiguration/entity/{entityId}
   */
  async getByEntity(
    version: string,
    entityId: number,
    countryCode?: string,
    options?: any
  ): Promise<AxiosResponse<any>> {
    // Check if the method exists (after API generation)
    if ('apiVversionInvoiceConfigurationEntityEntityIdGet' in this.invoiceApi) {
      return (this.invoiceApi as any).apiVversionInvoiceConfigurationEntityEntityIdGet(
        version,
        entityId,
        countryCode,
        options
      );
    }

    // Temporary mock response
    console.warn(
      '⚠️ InvoiceConfiguration API not yet generated. Run: pnpm run api:generate'
    );
    return {
      data: {
        data: [],
        errors: null,
      },
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {} as any,
    } as AxiosResponse<any>;
  }

  /**
   * Create a new configuration
   * POST /api/v1/InvoiceConfiguration
   */
  async create(
    version: string,
    config: any,
    options?: any
  ): Promise<AxiosResponse<any>> {
    // Check if the method exists (after API generation)
    if ('apiVversionInvoiceConfigurationPost' in this.invoiceApi) {
      return (this.invoiceApi as any).apiVversionInvoiceConfigurationPost(
        version,
        config,
        options
      );
    }

    // Temporary mock response
    console.warn(
      '⚠️ InvoiceConfiguration API not yet generated. Run: pnpm run api:generate'
    );
    return {
      data: {
        data: { id: 1, ...config },
        errors: null,
      },
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {} as any,
    } as AxiosResponse<any>;
  }

  /**
   * Update an existing configuration
   * PUT /api/v1/InvoiceConfiguration/{id}
   */
  async update(
    version: string,
    id: number,
    config: any,
    options?: any
  ): Promise<AxiosResponse<any>> {
    // Check if the method exists (after API generation)
    if ('apiVversionInvoiceConfigurationIdPut' in this.invoiceApi) {
      return (this.invoiceApi as any).apiVversionInvoiceConfigurationIdPut(
        version,
        id,
        config,
        options
      );
    }

    // Temporary mock response
    console.warn(
      '⚠️ InvoiceConfiguration API not yet generated. Run: pnpm run api:generate'
    );
    return {
      data: {
        data: { id, ...config },
        errors: null,
      },
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {} as any,
    } as AxiosResponse<any>;
  }

  /**
   * Delete a configuration (soft delete)
   * DELETE /api/v1/InvoiceConfiguration/{id}
   */
  async delete(
    version: string,
    id: number,
    options?: any
  ): Promise<AxiosResponse<any>> {
    // Check if the method exists (after API generation)
    if ('apiVversionInvoiceConfigurationIdDelete' in this.invoiceApi) {
      return (this.invoiceApi as any).apiVversionInvoiceConfigurationIdDelete(
        version,
        id,
        options
      );
    }

    // Temporary mock response
    console.warn(
      '⚠️ InvoiceConfiguration API not yet generated. Run: pnpm run api:generate'
    );
    return {
      data: {
        data: true,
        errors: null,
      },
      status: 200,
      statusText: 'OK',
      headers: {},
      config: {} as any,
    } as AxiosResponse<any>;
  }
}
